import { render, staticRenderFns } from "./ArticleModal.Style#Drawer.vue?vue&type=template&id=3e849638&scoped=true"
import script from "./ArticleModal.Style#Drawer.vue?vue&type=script&lang=js"
export * from "./ArticleModal.Style#Drawer.vue?vue&type=script&lang=js"
import style0 from "./ArticleModal.Style#Drawer.vue?vue&type=style&index=0&id=3e849638&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e849638",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e849638')) {
      api.createRecord('3e849638', component.options)
    } else {
      api.reload('3e849638', component.options)
    }
    module.hot.accept("./ArticleModal.Style#Drawer.vue?vue&type=template&id=3e849638&scoped=true", function () {
      api.rerender('3e849638', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/article/modules/ArticleModal.Style#Drawer.vue"
export default component.exports